<template>
  <div id="totalBox">
    <div class="bannerBox">
      <img src="../../assets/plan/banner.png" class="bannerIcon"/>
      <div class="plateFrame">
        <p class="plateFrameTitle">平台技术框架</p>
        <div class="plateFrameContent">
                  依托可视化GIS、CAN总线通讯、NB-IOT物联通信、北斗/GPS双模定位、超声以及人工智能等技术，自主研发移动APP、BOPS业务平台，具备独立开发智能道闸、智能地锁、智能车载终端等硬件系统能力。公司坚持“为青山绿水而战，为智慧出行而生，让人民群众停车不再难”的使命，始终把社会责任举过头顶，努力打造【任马停】中国智慧停车服务平台，致力于解决“难停车”、“乱停车”的社会痼疾。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Planbanner',
  data: function () {
    return {
      msg: '41'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 680px;
  background-color: RGBA(5, 1, 174, 1);
}
.bannerBox{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.bannerIcon{
  width: 878px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.plateFrame{
  width:1100px;
  height:180px;
  background:rgba(69,52,193,0.8);
  position: absolute;
  bottom: 30px;
  left: 50px;
  z-index: 2;
  padding: 22px 28px 35px 28px;
}
.plateFrameTitle{
  font-size:26px;
  font-weight:bold;
  color:rgba(255,255,255,1);
  line-height:36px;
}
.plateFrameContent{
  box-sizing: border-box;
  font-size:16px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:30px;
  margin-top: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/plan/banner.vue